module.exports = __webpack_public_path__ + "static/media/kb-ambassador-fr.a87353c3.png";